import React, { Component } from 'react';

import { withTranslation } from 'react-i18next'
import Moment from 'react-moment';
import CollapseIcon from '../../../images/collapse copy 5.png'
import ExpandIcon from '../../../images/expand copy 5.png'

class Kontaktperson extends Component {
    state = {
        isOpened: false
    }

    toggleKontaktperson = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var kontaktperson = this.props.kontaktperson

        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleKontaktperson}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title">{kontaktperson.navn}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                <div className="row">
                        <div className="column">
                            <div className="label">{t('navn')}</div>
                            <div className="value">{kontaktperson.navn}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('nummer')}</div>
                            <div className="value">{kontaktperson.nummer}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('adresse')}</div>
                            <div className="value">{kontaktperson.postadresselinje2 || kontaktperson.postadresselinje1}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('poststed')}</div>
                            <div className="value">{kontaktperson.postadresselinje3}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('kategori')}</div>
                            <div className="value">{kontaktperson.personkategoriKode}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('status')}</div>
                            <div className="value">{kontaktperson.personstatusKode}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('datofra')}</div>
                            <div className="value"><Moment local>{kontaktperson.datoFra}</Moment></div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(Kontaktperson)